import _extends from '@babel/runtime-corejs3/helpers/extends';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import React__default, { useState } from 'react';
import classNames from 'classnames';
import styles from './edc32f3f4b0f6fb3d40c4d3037d011f480e9026098fd16a97a473719db2f2d8a.cfe-internal.js';
import Input from './0313aac0a73c29ca9b860be5ca5b212107cd810318bb0b89176cc766dbf84b47.cfe-internal.js';
import '../Label/ccb438053671d3f4f4866aeae6546c2d1a0a64aa48a3d0efdd175e4b2c5ded2e.cfe-internal.js';
import { useFormFieldType } from '../FormField/f390dafefe74ba07f7da711a77443b7b51d96a6ad1aee47361fd1804064e9ba7.cfe-internal.js';
import Label from '../Label/9a6a268368a265bce1daf89b3b2abe908557e75abd2903920d33084576c4c867.cfe-internal.js';

var _excluded = ["label", "className", "style", "data-testid", "id", "onFocus", "onBlur", "labelProps", "inputProps"],
  _excluded2 = ["className"],
  _excluded3 = ["className"];
var InputField = /*#__PURE__*/React__default.forwardRef(function (_ref, ref) {
  var label = _ref.label,
    className = _ref.className,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style,
    dataTestId = _ref['data-testid'],
    id = _ref.id,
    onFocus = _ref.onFocus,
    onBlur = _ref.onBlur,
    _ref$labelProps = _ref.labelProps,
    labelProps = _ref$labelProps === void 0 ? {} : _ref$labelProps,
    _ref$inputProps = _ref.inputProps,
    inputProps = _ref$inputProps === void 0 ? {} : _ref$inputProps,
    rest = _objectWithoutProperties(_ref, _excluded);
  var labelClassName = labelProps.className,
    labelPropsWithoutClass = _objectWithoutProperties(labelProps, _excluded2);
  var inputClassName = inputProps.className,
    inputPropsWithoutClass = _objectWithoutProperties(inputProps, _excluded3);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    focused = _useState2[0],
    setFocused = _useState2[1];
  useFormFieldType('input');
  function handleFocus(e) {
    setFocused(true);
    onFocus === null || onFocus === void 0 || onFocus(e);
  }
  function handleBlur(e) {
    setFocused(false);
    onBlur === null || onBlur === void 0 || onBlur(e);
  }
  return /*#__PURE__*/React__default.createElement(Label, _extends({
    htmlFor: id,
    "data-testid": dataTestId,
    className: classNames(className, styles.label, labelClassName, _defineProperty({}, styles.focused, focused)),
    style: style
  }, labelPropsWithoutClass), label, /*#__PURE__*/React__default.createElement(Input, _extends({
    id: id,
    ref: ref,
    className: classNames(styles.wrappedInput, inputClassName),
    onBlur: handleBlur,
    onFocus: handleFocus
  }, rest, inputPropsWithoutClass)));
});

export { InputField as default };
